import { Component, Input } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';
import { CurrencyFormatPipe } from '@pedix-workspace/pedixapp-shared-pipes';
import { EndOrderTotals } from '../end-order-totals.service';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-order-total-details',
    templateUrl: './total-details.component.html',
    styleUrls: ['./total-details.component.scss'],
    imports: [TranslocoDirective, CurrencyFormatPipe]
})
export class OrderTotalDetailsComponent {
  @Input() orderTotals: EndOrderTotals;
}
